import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Axios from "../../axios/axios";
import { Link, useNavigate } from "react-router-dom";
import "./style.css";

export default function DashBoard() {
  const [totalOrders, setTotalOrders] = useState(0);
  const [rentedOutItemsCount, setRentedOutItemsCount] = useState(0);
  const [rentedOutItemsdata, setRentedOutItemsData] = useState([]);

  const [totalPurchaseCost, setTotalPurchaseCost] = useState(0);
  const [nonReturnedOrders, SetNonReturnedOrders] = useState([]);
  const [error, setError] = useState("");
  const [showAll, setShowAll] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5); // show 5 records per page

  const displayedOrders = showAll
    ? nonReturnedOrders
    : nonReturnedOrders.slice(0, 2);
  const [visibleCount, setVisibleCount] = useState(5); // Show 10 products by default
  const [topProducts, setTopProducts] = useState([]);

  const [modalVisible, setModalVisible] = useState(false);
  const [rentOutToday, setRentOutToday] = useState(0);
  const [rentOutOrdersToday, setRentOutOrdersToday] = useState(null);
  const [pendingApprovalCount, setPendingApprovalCount] = useState(0);
  const [kycPendingCount, setKycPendingCount] = useState(0);
  const [cancelRequestCount, setCancelRequestCount] = useState(0);
  const [todayRevenue, setTodayRevenue] = useState(0);

  const navigate = useNavigate();

  const handleModalOpen = () => {
    setModalVisible(true); // Show modal
  };

  const handleModalClose = () => {
    setModalVisible(false); // Hide modal
  };

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 10); // Increase count by 10
  };

  useEffect(() => {
    fetchTopProducts();
    fetchData();
  }, []);
  const fetchData = async () => {
    try {
      const response = await Axios.get("/api/order/item/totalorder"); // Your API endpoint
      const pendingRes = await Axios.get("/api/order/pending/count");
      const data = response.data;
      console.log(response.data, "  ");

      if (data.success) {
        setTotalOrders(data.totalOrders);
        setTotalPurchaseCost(data.totalPurchaseCost);
        SetNonReturnedOrders(data.nonReturnedOrders);
        setRentedOutItemsCount(data.rentedOutItemsCount);
        setRentedOutItemsData(data.rentedOutItems);
        setRentOutToday(data.rentedOutTodayCount);
        setRentOutOrdersToday(data.rentOutOrdersToday);
        setPendingApprovalCount(pendingRes.data.count);
        setTodayRevenue(data.todayRevenue);
      } else {
        setError("Failed to fetch data");
      }
    } catch (err) {
      setError("Error fetching data");
    }
  };

  console.log(rentedOutItemsCount);
  const fetchTopProducts = async () => {
    try {
      const response = await Axios.get("/api/order/item/top-products");
      if (response.data.success) {
        setTopProducts(response.data.topProducts);
      }
    } catch (err) {
      console.error("Error fetching top products", err);
    }
  };
  const [allProducts, setAllProducts] = useState([]);
  const [products, setProducts] = useState([]);
  const [searchKey, setSearchKey] = useState("");

  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = async () => {
    try {
      const res = await Axios.post(`/api/user/list/pending`);
      setProducts(res?.data?.users);
      setAllProducts(res?.data?.users); // keep full copy for frontend filtering
    } catch (err) {
      console.error("Error fetching pending users:", err);
    }
  };

  // frontend search by customer name
  const searchByName = (value) => {
    setSearchKey(value);
    if (value.trim() === "") {
      setProducts(allProducts);
    } else {
      const filtered = allProducts.filter((user) =>
        user.name.toLowerCase().includes(value.toLowerCase()),
      );
      setProducts(filtered);
      setCurrentPage(1); // reset to first page after search
    }
  };

  const search = (value) => {
    setSearchKey(value);
  };
  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = products.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(products.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const fetchKycCount = async () => {
    try {
      const { data } = await Axios.get("/api/user/users-with-pending");
      setKycPendingCount(data.length); // ✅ count
    } catch (err) {
      console.error("Error fetching KYC count", err);
    }
  };
  const fetchCancelCount = async () => {
    try {
      const { data } = await Axios.get("/api/user/cancel/count");
      setCancelRequestCount(data.count);
    } catch (err) {
      console.error("Error fetching cancel count", err);
    }
  };
  useEffect(() => {
    fetchKycCount();
    fetchCancelCount();
  }, []);
  return (
    <>
      {/* <div className="custom-row">
        <div className="custom-col-12 custom-grid-margin">
          <div className="custom-row">
            <div className="custom-col-12 custom-col-xl-8 custom-margin-bottom">
              <h3 className="custom-font-weight-bold">Welcome to Adcaster admin panel</h3>
              <h6 className="custom-font-weight-normal custom-margin-bottom-0">Manage all things here...</h6>
            </div>
          </div>
        </div>
      </div> */}

      <div
        className="custom-container mt-5"
        style={{ backgroundColor: "white" }}
      >
        <div className="custom-row">
          {/* Total Orders */}
          <div className="custom-col-sm-12 custom-col-md-4 custom-margin-bottom">
            <div className="custom-card custom-shadow-card">
              <Link
                to="/orders"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <div className="custom-card-body" style={{ cursor: "pointer" }}>
                  <h5 className="custom-card-title">Total Orders</h5>
                  <div
                    className="custom-order-count-icon custom-order-count"
                    style={{ backgroundColor: "#191970" }}
                  >
                    {totalOrders || "Loading..."}
                  </div>
                </div>
              </Link>
              <Link
                to="/order-approvals"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <div className="custom-card-body" style={{ cursor: "pointer" }}>
                  <h5 className="custom-card-title">Orders To Approve</h5>
                  <div
                    className="custom-order-count-icon custom-order-count"
                    style={{ backgroundColor: "#191970" }}
                  >
                    {pendingApprovalCount || 0}
                  </div>
                </div>
              </Link>
            </div>
          </div>

          <div className="custom-col-sm-12 custom-col-md-4 custom-margin-bottom">
            <div className="custom-card custom-shadow-card rentout-card">
              <div className="rentout-section">
                <h5 className="custom-card-title">Rent Out Item</h5>
                <div
                  className="custom-order-count-icon custom-order-count"
                  onClick={handleModalOpen}
                >
                  {rentedOutItemsCount || "Loading..."}
                </div>
              </div>

              <div className="rentout-section">
                <h5 className="custom-card-title">Orders to Rent Out Today</h5>
                <div className="custom-order-count-icon custom-order-count">
                  {rentOutOrdersToday !== null
                    ? rentOutOrdersToday
                    : "Loading..."}
                </div>
              </div>

              <div className="rentout-section">
                <h5 className="custom-card-title">Rent Out Items Today</h5>
                <div
                  className="custom-order-count-icon custom-order-count"
                  onClick={() => navigate("/report?type=scheduled")}
                >
                  {rentOutToday !== null ? rentOutToday : "Loading..."}
                </div>
              </div>
            </div>
          </div>
          {/* Modal for displaying rented out items */}
          {modalVisible && (
            <div className="modal-overlay">
              <div className="modal-content">
                <div className="modal-header">
                  <h5>Rented Out Products</h5>
                  <button
                    onClick={handleModalClose}
                    className="btn btn-primary"
                  >
                    X
                  </button>
                </div>
                <div className="modal-body scrollable">
                  {rentedOutItemsdata.length === 0 ? (
                    <p>No rented out products found.</p>
                  ) : (
                    <div className="row">
                      {rentedOutItemsdata.map((item, index) => (
                        <div key={index} className="col-md-6 mb-3">
                          <div className="custom-card custom-shadow-card">
                            <div className="custom-card-body">
                              <h6 className="custom-card-title">
                                {item.productName}
                              </h6>
                              <Link
                                to={`/order/${item.orderId}`}
                                style={{
                                  color: "black",
                                  textDecoration: "none",
                                }}
                              >
                                <p>
                                  <strong>Item Code:</strong> {item.itemCode}
                                </p>
                              </Link>
                              <p>
                                <strong>Serial Number:</strong>{" "}
                                {item.serialNumber}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div className="modal-footer">
                  <button
                    onClick={handleModalClose}
                    className="btn btn-primary"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Top 10 Products */}
          <div className="custom-col-sm-12 custom-col-md-4 custom-margin-bottom">
            <div className="custom-card custom-shadow-card">
              {/* Static Header */}
              <div className="custom-card-header p-3">
                <h5 className="custom-card-title m-0">Profit Items</h5>
              </div>

              {/* Scrollable Body */}
              <div
                className="custom-card-body custom-card-body-scrollable"
                style={{ maxHeight: "300px", overflowY: "auto" }}
              >
                <ul className="custom-order-list">
                  {topProducts.length > 0 ? (
                    topProducts.map((product, index) => (
                      <li key={index} className="custom-order-item">
                        <h5>{product.productName}</h5>
                        <p>
                          <strong>Total Quantity:</strong>{" "}
                          {product.totalQuantity}
                        </p>
                        <p>
                          <strong>Total Revenue:</strong> $
                          {product.totalRevenue}
                        </p>
                      </li>
                    ))
                  ) : (
                    <p>Loading...</p>
                  )}
                </ul>

                {/* Show more/less button */}
                {nonReturnedOrders.length > 2 && (
                  <button
                    className="custom-toggle-button custom-btn custom-btn-primary"
                    onClick={() => setShowAll(!showAll)}
                  >
                    {showAll ? "Show Less" : "Show More"}
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Pending Customer Balance */}
        </div>

        <div className="custom-row">
          {/* Customer Approval */}
          <div className="custom-col-sm-12 custom-col-md-8 custom-margin-bottom">
            <div className="custom-card custom-shadow-card">
              {/* Static header (won't scroll) */}
              <div className="custom-card-header p-3">
                <div className="d-flex justify-content-between align-items-center">
                  <h5 className="custom-card-title m-0">
                    Pending Customer Balance
                  </h5>

                  {/* 📑 Pagination Controls */}
                  <div className="d-flex align-items-center">
                    <button
                      className="btn btn-sm btn-outline-secondary"
                      onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                      disabled={currentPage === 1}
                    >
                      Prev
                    </button>
                    <span style={{ margin: "0 8px", fontSize: "0.9rem" }}>
                      {currentPage} /{" "}
                      {Math.ceil(products.length / itemsPerPage)}
                    </span>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={() =>
                        setCurrentPage((p) =>
                          Math.min(
                            p + 1,
                            Math.ceil(products.length / itemsPerPage),
                          ),
                        )
                      }
                      disabled={
                        currentPage ===
                        Math.ceil(products.length / itemsPerPage)
                      }
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>

              {/* Scrollable body */}
              <div
                className="custom-card-body"
                style={{ maxHeight: "300px", overflowY: "auto" }}
              >
                {/* 🔍 Search Input */}
                <input
                  type="text"
                  placeholder="Search by customer name..."
                  value={searchKey}
                  onChange={(e) => searchByName(e.target.value)}
                  className="form-control mb-3"
                />

                {/* 📋 Table */}
                <table className="custom-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Address</th>
                      <th>Phone</th>
                      <th>Balance</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems?.length > 0 ? (
                      currentItems.map((user, index) => (
                        <tr key={user._id}>
                          <td>{indexOfFirstItem + index + 1}</td>
                          <td>
                            <Link to={`/user/${user._id}`}>{user.name}</Link>
                          </td>
                          <td>{user.address1?.slice(0, 15)}</td>
                          <td>
                            {user.phone}
                            {user.phone1 ? ` / ${user.phone1}` : ""}
                          </td>
                          <td>
                            <div
                              className={
                                user.balanceAmount > 5000
                                  ? "custom-badge custom-badge-danger"
                                  : "custom-badge custom-badge-warning"
                              }
                            >
                              {user.balanceAmount.toFixed(2)}
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={5}>No customer found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Total Stock Amount */}
          <div className="custom-col-sm-12 custom-col-md-4 custom-margin-bottom">
            <div className="custom-card custom-shadow-card">
              <div className="custom-card-body">
                <h5 className="custom-card-title">Total Stock Amount</h5>
                <p
                  className="custom-card-text custom-order-count"
                  style={{ backgroundColor: "#191970" }}
                >
                  ₹{totalPurchaseCost || "Loading..."}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="custom-row">
          {/* Profit Amount */}
          {/* Top Products */}
          <div className="custom-col-sm-12 custom-col-md-4 custom-margin-bottom">
            <div className="custom-card custom-shadow-card">
              {/* Static Header */}
              <div className="custom-card-header p-3">
                <h5 className="custom-card-title m-0">Top Products</h5>
              </div>

              {/* Scrollable Body */}
              <div
                className="custom-card-body custom-card-body-scrollable"
                style={{ maxHeight: "300px", overflowY: "auto" }}
              >
                <ul>
                  {nonReturnedOrders.length > 0
                    ? nonReturnedOrders.map((product, index) => (
                        <li key={index}>{product.productName}</li>
                      ))
                    : "Loading..."}
                </ul>
              </div>
            </div>
          </div>

          <div className="custom-col-sm-12 custom-col-md-4 custom-margin-bottom">
            <div className="custom-card custom-shadow-card">
              <div className="custom-card-body">
                <h5 className="custom-card-title">Today's Revenue</h5>

                <div
                  className="custom-order-count-icon custom-order-count"
                  style={{
                    backgroundColor: "#198754",
                    marginTop: "20px",
                  }}
                >
                  ₹ {todayRevenue?.toFixed(2)}
                </div>

                <p className="mt-3" style={{ fontSize: "14px", color: "#666" }}>
                  Total revenue generated today
                </p>
              </div>
            </div>
          </div>

          {/* This month income expense */}
          <div className="custom-col-sm-12 custom-col-md-4 custom-margin-bottom">
            <div className="custom-card custom-shadow-card">
              <div className="custom-card-body">
                <h5 className="custom-card-title">This Month Income Expense</h5>
                <p className="custom-card-text">-----------------</p>
                <p className="custom-card-text">we will update soon...</p>
              </div>
            </div>
          </div>
        </div>
        <div className="custom-row">
          <div className="custom-col-sm-12  custom-col-md-4 custom-margin-bottom">
            <div className="custom-card custom-shadow-card">
              <div className="custom-card-body">
                <div>
                  <h5 className="custom-card-title">Customer KYC Approval</h5>
                  <Link
                    to="/pending/view"
                    className="custom-order-count-icon custom-order-count"
                    style={{
                      backgroundColor: "#191970",
                      color: "#fff",
                      textDecoration: "none",
                    }}
                  >
                    {kycPendingCount || 0}
                  </Link>
                </div>
                <div className="mt-3">
                  <h5 className="custom-card-title">Order Cancel Requests</h5>
                  <Link
                    to="/order-cancellations"
                    className="custom-order-count-icon custom-order-count"
                    style={{
                      backgroundColor: "#191970",
                      color: "#fff",
                      textDecoration: "none",
                    }}
                  >
                    {cancelRequestCount || 0}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Error handling */}
        {error && (
          <div className="custom-alert custom-alert-danger">{error}</div>
        )}
      </div>
    </>
  );
}
